import { Button, Tooltip } from 'antd';
import { useState } from 'react';
import TransferUnitsModal from './TransferUnitsModal';

const TransferUnitsButton = ({ units = [], onTransferred, ...buttonProps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedUnits = units?.filter(Boolean);
  const selectedCount = selectedUnits?.length || 0;

  return (
    <>
      <Tooltip
        title={
          selectedCount
            ? `Move the ${selectedCount} selected ${
                selectedCount === 1 ? 'unit' : 'units'
              } to another library.`
            : 'Select one or more units to move them to another library.'
        }
        placement="bottom"
      >
        <span>
          <Button
            {...buttonProps}
            disabled={!selectedCount}
            onClick={() => setIsOpen(true)}
          >
            {selectedCount ? `Transfer (${selectedCount})` : 'Transfer'}
          </Button>
        </span>
      </Tooltip>
      <TransferUnitsModal
        open={isOpen}
        units={selectedUnits}
        onClose={() => setIsOpen(false)}
        onTransferred={onTransferred}
      />
    </>
  );
};

export default TransferUnitsButton;
